export const REQUEST_TOOL_URL =
  'https://docs.google.com/forms/d/e/1FAIpQLScvRnlGgYbrlNOvpJNGt-bv8yF_0Rb3NKO4hQ9HFP7lB5q7ZQ/viewform?usp=publish-editor';
export const REPORT_ISSUE_URL =
  'https://docs.google.com/forms/d/e/1FAIpQLSeBVpRUO8tDYaPWakvZwrkYukzx83y-KbD6ysfYCg0u0buW2g/viewform?usp=publish-editor';
